import { theme } from "@tm/utility/global";
import styled from "styled-components";

export const AddTravContainer = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 24px;
`;

export const AddTravHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
`;

export const Separator = styled.div`
  height: 1px;
  background: #d8d8d8;
  margin: 16px 0;
`;

export const ArrowButtonWrap = styled.span`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  cursor: pointer;
`;

export const AddViewButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin: 8px 0;
`;

export const AddButtonWrap = styled.div<{ isDisabled?: boolean }>`
  display: flex;
  ${(props) =>
    props.isDisabled
      ? `color: ${theme.disabledGrey};`
      : `color: ${theme.blueText}`};
  align-item: baseline;
  margin: 14px 33px 14px 30px;

  cursor: pointer;
  align-items: center;
  img {
    width: 16px;
    height: 16px;
  }
  span {
    font-weight: 800;
    font-size: 14px;
  }
`;

export const ViewButtonWrap = styled.div`
  display: flex;
  color: ${theme.blueText};
  cursor: pointer;
  align-items: center;
  margin: 14px 30px 14px 0;
  span {
    font-weight: 800;
    font-size: 14px;
  }

  img {
    width: 9px;
    height: 9px;
  }
`;

export const ArrowIcon = styled.img<{ isRotated?: boolean }>`
  width: 9px;
  height: 9px;
  margin-left: 8px;
  transform: ${(props) =>
    props.isRotated ? "rotate(180deg)" : "rotate(0deg)"};
  transition: transform 0.3s ease-in-out;
`;
